import { closeModal } from "../../ReduxToolkit/Slice/UserProfileDetailsModalSlice";
import { AppDispatch } from "../../ReduxToolkit/Store";
import { ModalType } from "../../Types/UserProfileDetails";
import { getTodayDateTime } from "../../utils/dateUtils";
import ConfirmDeleteDialog from "../ConfirmDeleteDialog";
import * as XLSX from "xlsx";

export interface IExportDialogProps<T = any> {
  modalType: ModalType | null;
  targetModalType: ModalType;
  isOpen: boolean;
  dispatch: AppDispatch;
  fileName: string;
  sheetName: string;
  data: T[] | null;
  dialogLabel: string;
  addDateSuffix?: boolean;
  transform: (data: T[], index?: number) => any[];
}

const ExportDialog = <T,>({
  data,
  dispatch,
  fileName = "report.xlsx",
  isOpen,
  modalType,
  sheetName = "Sheet1",
  targetModalType,
  transform,
  dialogLabel,
  addDateSuffix = false,
}: IExportDialogProps<T>) => {
  const handleClose = () => dispatch(closeModal());
  const handleExport = () => {
    const list = data || [];
    if (!Array.isArray(list) || list.length === 0) {
      alert("No Data Export");
      handleClose();
      return;
    }

    const transformed = transform(list);

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(transformed);

    // Auto-adjust column widths based on max length of content in each column
    const colWidths = Object.keys(transformed[0] || {}).map((key) => {
      const maxLength = Math.max(
        key.length, // header length
        ...transformed.map((row) => (row[key] ? String(row[key]).length : 0))
      );
      return { wch: maxLength + 2 }; // +2 for padding
    });

    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    const today = getTodayDateTime();
    const finalFileName = addDateSuffix
      ? `${fileName.replace(/\.xlsx$/, "")} ${today}.xlsx`
      : fileName;

    XLSX.writeFile(wb, finalFileName, { bookType: "xlsx" });
    handleClose();
  };

  return modalType === targetModalType ? (
    <ConfirmDeleteDialog
      isOpen={isOpen}
      handleToggle={handleClose}
      label={dialogLabel}
      handleClickFirstBtn={handleExport}
    />
  ) : null;
};

export default ExportDialog;
